import React from "react";
import Hero from "../components/Hero";
import Features from "../components/Features";
import NewItems from "../components/NewItems";
import FeaturesSecond from "../components/FeaturesSecond";
import Testimonial from "../components/Testimonial";
import NewsLetters from "../components/NewsLetters";
import Newsletter from "../components/Newsletter";
import BreakingTicker from "../components/BreakingTicker";  // ← ADD THIS
import LatestNews from "../components/LatestNews";         


const Home = () => {
	return (
		<>
		<Hero />
		
			<BreakingTicker />     
			<Features />
			<LatestNews />         
			<FeaturesSecond />
			<NewItems />
			<Testimonial />
			<Newsletter />          
			<NewsLetters />    
		</>
	);
};

export default Home;